import { render, staticRenderFns } from "./OverOns.vue?vue&type=template&id=58765fa5&scoped=true"
import script from "./OverOns.vue?vue&type=script&lang=ts"
export * from "./OverOns.vue?vue&type=script&lang=ts"
import style0 from "./OverOns.vue?vue&type=style&index=0&id=58765fa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58765fa5",
  null
  
)

export default component.exports